const TRANSLATIONS = {
  en: {
    lobby_title: "Pigeon Supply",
    lobby_subtitle: "Supply Management Platform",
    select_hub: "Select Hub",
    select_role: "Select Your Role",
    planner: "Planner",
    machinist: "Machinist",
    driver: "Driver",
    viewer: "Viewer",
    language_gate: "Select Language",
    enter_dashboard: "Enter Dashboard",
    back: "Back",
    exit: "Exit",
    planner_dashboard: "Planner Dashboard",
    fleet_intelligence: "Fleet Intelligence",
    all_regions: "All Regions",
    search_placeholder: "Search sites...",
    sites: "Sites",
    machines: "Machines",
    drivers_title: "Drivers",
    active: "Active",
    offline: "Offline",
    efficiency: "Efficiency",
    stops: "Stops",
    refuelings: "Refuelings",
    fleet_volume: "Fleet Volume",
    active_drivers: "Active",
    daily_progress: "Daily Progress",
    analyze: "Analyze",
    approve: "Approve",
    data_synced: "Data Synchronized",
    ping_sent: "Message Sent",
    high_five_sent: "High-Five Sent!",
    send_message: "Send Message",
    direct_communication: "Direct Communication",
    send_message_placeholder: "Type a message...",
    no_stops_yet: "No stops yet",
    recent_communication: "Recent Communication",
    recent_alerts: "Recent Alerts",
    live_feed: "Live Feed",
    new_requests: "New Requests",
    in_progress: "In Progress",
    completed: "Completed",
    fun_request: "Fun Request",
    fun_placeholder: "French fries with mayonnaise?",
    driver_dashboard: "Driver Dashboard",
    start_day: "Start Day",
    stop_day: "Stop Day",
    day_status: "Day Status",
    quick_actions: "Quick Actions",
    pause: "Break",
    breakdown: "Breakdown",
    my_planning: "My Planning",
    no_planning: "No planning yet",
    checklist: "Pre-Departure Checklist",
    mirrors: "Mirrors & Lights",
    tires: "Tires & Pressure",
    fuel_check: "Fuel Level Check",
    documents: "Documents & License",
    safety_gear: "Safety Gear",
    confirm_delivery: "Confirm Delivery",
    diesel_liters: "Diesel (L)",
    adblue_liters: "AdBlue (L)",
    deliver: "Deliver",
    messages: "Messages",
    info_hub: "Info Hub",
    high_five_wall: "High-Five Wall",
    my_rating: "My Rating",
    give_planner: "Give Planner",
    machinist_dashboard: "Machinist Dashboard",
    select_site: "Select Site",
    current_site: "Current Site",
    machine_pool: "Machine Pool",
    fuel_request: "Fuel Request",
    tank_level: "Tank Level",
    adblue_needed: "AdBlue Needed",
    action_center: "Action Center",
    request_type: "Request Type",
    in_use: "In Use",
    defect: "Defect",
    maintenance: "Maintenance",
    transport_needed: "Transport",
    target_destination: "Target Destination",
    details_reason: "Details / Reason",
    send_to_planner: "Send to Planner",
    add_rental: "Add Rental Machine",
    machine_type: "Machine Type",
    fleet_id: "Fleet ID / Label",
    confirm_import: "Register Machine",
    echo_tracker: "Request Tracker",
    waiting: "Waiting",
    loading: "Loading...",
    error: "Error",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    confirm: "Confirm",
    no_data: "No data",
    refresh: "Refresh",
    calendar: "Calendar",
    feedback: "Feedback",
    feedback_placeholder: "Share your feedback about this site...",
    submit_feedback: "Submit Feedback",
    switch_driver: "Switch Driver",
    reschedule: "Reschedule",
    welcome: "Welcome",
    continue_lang: "Continue",
    choose_language: "Choose your language to get started",
    // Hub Portal & Invite
    my_hubs: "My Hubs",
    create_hub: "Create Hub",
    hub_lobby: "Hub Lobby",
    hub_occupancy: "Hub Occupancy",
    invite_crew: "Invite Crew Members",
    generate_link: "Generate Link",
    needed_to_deploy: "Needed to deploy",
    youre_invited: "You're Invited",
    join_as: "Join as",
    your_role: "Your Role",
    display_name: "Your Display Name",
    how_crew_sees_you: "How the crew sees you",
    invite_used: "Invite Used",
    invite_used_desc: "This invite link has already been used",
    go_to_hubs: "Go to My Hubs",
    join_the_crew: "Join the crew and start working",
    active_crew: "Active Crew",
    enter_hub: "Enter Hub Dashboard",
    deploy_hub: "Deploy Hub",
    hub_waiting: "Waiting for crew",
    hub_deployed: "Deployed",
    qr_code: "QR Code",
    share: "Share",
    copy: "Copy",
    copied: "Copied",
    download: "Download",
    // Install & PWA
    install_app: "Install App",
    install_title: "Install Pigeon Supply",
    install_desc: "Works offline. Fast. Native feel on any device.",
    your_device: "Your Device",
    how_to_install: "How to install",
    app_installed: "App Installed",
    open_app: "Open Pigeon Supply",
    // Analytics
    hub_analytics: "Hub Analytics",
    total_deliveries: "Total Deliveries",
    feedback_score: "Feedback Score",
    activity_30d: "Activity (30 days)",
    subjects_per_site: "Subjects per Site",
    // General
    settings: "Settings",
    language: "Language",
    notifications: "Notifications",
    profile: "Profile",
    hub_details: "Hub Details",
    members: "Members",
    // Landing Page
    supply_platform: "Supply Platform",
    nav_pricing: "Pricing",
    nav_contact: "Contact",
    launch_app: "Launch App",
    hero_badge: "Trusted by logistics teams across Europe",
    hero_line1: "Supply your sites.",
    hero_line2: "Command",
    hero_line3: "your flock.",
    hero_desc: "The intelligent supply management platform for construction logistics. Closed-loop communication between Planners, Drivers, and Machinists — in real time.",
    start_free_trial: "Start Free Trial",
    view_pricing: "View Pricing",
    stat_hubs: "Active Hubs",
    stat_drivers: "Drivers Managed",
    stat_tracked: "Liters Tracked",
    stat_languages: "Languages",
    section1_tag: "On-Site Intelligence",
    section1_line1: "Assess the",
    section1_line2: "situation in no time",
    section1_p1: "Equip your field crew with purpose-built apps. The <strong>Machinist Portal</strong> enables real-time requesting, machine status communication, and new site rental requirements — straight from the ground.",
    section1_p2: "On-site access directions and delivery verifications flow through the <strong>Echo Tank</strong> — your live request tracker. The <strong>Driver App</strong> instantly updates deliveries and captures feedback.",
    section2_tag: "Strategic Decisions",
    section2_line1: "Take the right decisions",
    section2_line2: "with",
    section2_line3: "confidence",
    section2_p1: "Make the calls that matter for your supply objectives. <strong>Expand your operational map</strong> without hesitation — add new sites, regions, and supply corridors as your projects grow.",
    section2_p2: "Invite contractors to your hub and assign them seamlessly. Arrange refueling down to the last detail with <strong>instant delivery checks</strong>, automated approvals, and real-time visibility.",
    section3_tag: "Total Oversight",
    section3_line1: "Maintain a",
    section3_line2: "bird's eye",
    section3_line3: "view",
    section3_p1: "The <strong>Planner Dashboard</strong> is your command centre — manage driver planning, route assignments, and HR profiles from a single view. Monitor fleet health and oversee service operations.",
    section3_p2: "Dedicated <strong>Service and Transport portals</strong> keep specialized teams coordinated. Direct your flock toward ever-expanding horizons with complete operational visibility.",
    section4_tag: "Operational Mastery",
    section4_line1: "Enjoy the",
    section4_line2: "freeflow",
    section4_line3: "of information",
    section4_p1: "Every data point at your fingertips. Maintain operational efficiency with <strong>pragmatism</strong>, confidence, and technological ease. No more lost requests or blind spots.",
    section4_p2: "From PDF reports to real-time feeds, from AI-powered data import to multi-language support — <strong>Pigeon Supply</strong> turns complexity into clarity.",
    get_started_free: "Get Started Free",
    testimonial: "Pigeon Supply transformed our fuel logistics. We went from phone calls and spreadsheets to real-time coordination in a week.",
    testimonial_author: "Marc V. / Fleet Manager / Construction NV",
    choose_your_plan: "Choose your plan",
    pricing_desc: "Start free. Scale when ready. 14-day trial on Basic.",
    best_value: "Best Value",
    upgrade_to_unlock: "Upgrade to unlock",
    cta_line1: "Ready to direct",
    cta_line2: "your flock?",
    cta_desc: "Start your 14-day free trial. No credit card required.",
    launch_pigeon: "Launch Pigeon Supply",
    footer_desc: "Intelligent supply management for construction logistics teams.",
    product: "Product",
    legal: "Legal",
    support: "Support",
    terms_of_service: "Terms of Service",
    privacy_policy: "Privacy Policy",
    refund_policy: "Refund Policy",
    gdpr_cookies: "GDPR & Cookies",
    contact_us: "Contact Us",
    payment_success: "Payment successful! Welcome to Pigeon Supply.",
    verifying_payment: "Verifying payment...",
  },
  nl: {
    lobby_title: "Pigeon Supply",
    lobby_subtitle: "Bevoorradingsplatform",
    select_hub: "Selecteer Hub",
    select_role: "Selecteer Je Rol",
    planner: "Planner",
    machinist: "Machinist",
    driver: "Chauffeur",
    viewer: "Kijker",
    language_gate: "Selecteer Taal",
    enter_dashboard: "Naar Dashboard",
    back: "Terug",
    exit: "Sluiten",
    planner_dashboard: "Planner Dashboard",
    fleet_intelligence: "Vloot Intelligentie",
    all_regions: "Alle Regio's",
    search_placeholder: "Zoek werven...",
    sites: "Werven",
    machines: "Machines",
    drivers_title: "Chauffeurs",
    active: "Actief",
    offline: "Offline",
    efficiency: "Efficiëntie",
    stops: "Stops",
    refuelings: "Tankbeurten",
    fleet_volume: "Vloot Volume",
    active_drivers: "Actief",
    daily_progress: "Dagvoortgang",
    analyze: "Analyse",
    approve: "Goedkeuren",
    data_synced: "Data Gesynchroniseerd",
    ping_sent: "Bericht Verzonden",
    high_five_sent: "High-Five Verzonden!",
    send_message: "Stuur Bericht",
    direct_communication: "Directe Communicatie",
    send_message_placeholder: "Typ een bericht...",
    no_stops_yet: "Nog geen stops",
    recent_communication: "Recente Communicatie",
    recent_alerts: "Recente Meldingen",
    live_feed: "Live Feed",
    new_requests: "Nieuwe Aanvragen",
    in_progress: "In Behandeling",
    completed: "Afgerond",
    fun_request: "Fun Request",
    fun_placeholder: "Frietjes met mayonaise?",
    driver_dashboard: "Chauffeur Dashboard",
    start_day: "Start Dag",
    stop_day: "Stop Dag",
    day_status: "Dagstatus",
    quick_actions: "Snelle Acties",
    pause: "Pauze",
    breakdown: "Panne",
    my_planning: "Mijn Planning",
    no_planning: "Nog geen planning",
    checklist: "Vertrekchecklist",
    mirrors: "Spiegels & Lichten",
    tires: "Banden & Druk",
    fuel_check: "Brandstofniveau",
    documents: "Documenten & Rijbewijs",
    safety_gear: "Veiligheidsuitrusting",
    confirm_delivery: "Bevestig Levering",
    diesel_liters: "Diesel (L)",
    adblue_liters: "AdBlue (L)",
    deliver: "Leveren",
    messages: "Berichten",
    info_hub: "Info Hub",
    high_five_wall: "High-Five Muur",
    my_rating: "Mijn Score",
    give_planner: "Geef Planner",
    machinist_dashboard: "Machinist Dashboard",
    select_site: "Selecteer Werf",
    current_site: "Huidige Werf",
    machine_pool: "Machinepark",
    fuel_request: "Tankverzoek",
    tank_level: "Tankniveau",
    adblue_needed: "AdBlue Nodig",
    action_center: "Actie Centrum",
    request_type: "Type Verzoek",
    in_use: "In Gebruik",
    defect: "Defect",
    maintenance: "Onderhoud",
    transport_needed: "Transport",
    target_destination: "Doellocatie",
    details_reason: "Details / Reden",
    send_to_planner: "Stuur naar Planner",
    add_rental: "Huurmachine Toevoegen",
    machine_type: "Machinetype",
    fleet_id: "Vloot ID / Label",
    confirm_import: "Machine Registreren",
    echo_tracker: "Verzoek Tracker",
    waiting: "Wachtend",
    loading: "Laden...",
    error: "Fout",
    save: "Opslaan",
    cancel: "Annuleren",
    delete: "Verwijderen",
    confirm: "Bevestigen",
    no_data: "Geen data",
    refresh: "Vernieuwen",
    calendar: "Kalender",
    feedback: "Feedback",
    feedback_placeholder: "Deel je feedback over deze werf...",
    submit_feedback: "Verstuur Feedback",
    switch_driver: "Wissel Chauffeur",
    reschedule: "Herplannen",
    welcome: "Welkom",
    continue_lang: "Doorgaan",
    choose_language: "Kies je taal om te beginnen",
    my_hubs: "Mijn Hubs",
    create_hub: "Hub Aanmaken",
    hub_lobby: "Hub Lobby",
    hub_occupancy: "Hub Bezetting",
    invite_crew: "Nodig Crew Uit",
    generate_link: "Link Genereren",
    needed_to_deploy: "Nodig voor deployment",
    youre_invited: "Je Bent Uitgenodigd",
    join_as: "Word lid als",
    your_role: "Jouw Rol",
    display_name: "Jouw Weergavenaam",
    how_crew_sees_you: "Hoe de crew je ziet",
    invite_used: "Uitnodiging Gebruikt",
    invite_used_desc: "Deze uitnodigingslink is al gebruikt",
    go_to_hubs: "Ga naar Mijn Hubs",
    join_the_crew: "Word lid van de crew en begin te werken",
    active_crew: "Actieve Crew",
    enter_hub: "Ga naar Hub Dashboard",
    deploy_hub: "Hub Deployen",
    hub_waiting: "Wachten op crew",
    hub_deployed: "Gedeployed",
    qr_code: "QR Code",
    share: "Delen",
    copy: "Kopiëren",
    copied: "Gekopieerd",
    download: "Downloaden",
    install_app: "App Installeren",
    install_title: "Installeer Pigeon Supply",
    install_desc: "Werkt offline. Snel. Natuurlijk gevoel op elk apparaat.",
    your_device: "Jouw Apparaat",
    how_to_install: "Hoe te installeren",
    app_installed: "App Geïnstalleerd",
    open_app: "Open Pigeon Supply",
    hub_analytics: "Hub Analyse",
    total_deliveries: "Totaal Leveringen",
    feedback_score: "Feedbackscore",
    activity_30d: "Activiteit (30 dagen)",
    subjects_per_site: "Machines per Werf",
    settings: "Instellingen",
    language: "Taal",
    notifications: "Meldingen",
    profile: "Profiel",
    hub_details: "Hub Details",
    members: "Leden",
    // Landing Page
    supply_platform: "Logistiek Platform",
    nav_pricing: "Tarieven",
    nav_contact: "Contact",
    launch_app: "Start App",
    hero_badge: "Vertrouwd door logistieke teams in heel Europa",
    hero_line1: "Voorzie je werven.",
    hero_line2: "Beheer",
    hero_line3: "je vloot.",
    hero_desc: "Het slimme bevoorradingsplatform voor bouwlogistiek. Gesloten communicatie tussen Planners, Chauffeurs en Machinisten — in real time.",
    start_free_trial: "Gratis Proberen",
    view_pricing: "Bekijk Tarieven",
    stat_hubs: "Actieve Hubs",
    stat_drivers: "Chauffeurs Beheerd",
    stat_tracked: "Liters Bijgehouden",
    stat_languages: "Talen",
    section1_tag: "Terrein Inzicht",
    section1_line1: "Beoordeel de",
    section1_line2: "situatie in één oogopslag",
    section1_p1: "Geef je terreinploeg een eigen app. Het <strong>Machinist Portaal</strong> maakt live aanvragen, machinestatus en huurbehoeften mogelijk — rechtstreeks vanop de werf.",
    section1_p2: "Toegangsrichtingen en leveringscontroles lopen via de <strong>Echo Tank</strong>. De <strong>Chauffeur App</strong> werkt leveringen bij en registreert feedback per rit.",
    section2_tag: "Strategische Keuzes",
    section2_line1: "Neem de juiste beslissingen",
    section2_line2: "met",
    section2_line3: "vertrouwen",
    section2_p1: "Neem de beslissingen die tellen. <strong>Breid je operationeel bereik uit</strong> — voeg werven, regio's en bevoorradingslijnen toe naarmate je projecten groeien.",
    section2_p2: "Nodig onderaannemers uit en wijs ze naadloos toe. Regel bevoorrading tot in het kleinste detail met <strong>directe leveringschecks</strong> en volledige zichtbaarheid.",
    section3_tag: "Totaal Overzicht",
    section3_line1: "Behoud een",
    section3_line2: "vogelperspectief",
    section3_line3: "overzicht",
    section3_p1: "Het <strong>Planner Dashboard</strong> is je commandocentrum — beheer chauffeurplanning, routes en profielen vanuit één scherm. Monitor wagenpark en service.",
    section3_p2: "<strong>Service- en Transportportalen</strong> houden gespecialiseerde teams op één lijn. Stuur je vloot aan met volledig operationeel overzicht.",
    section4_tag: "Operationele Grip",
    section4_line1: "Geniet van de",
    section4_line2: "vrije stroom",
    section4_line3: "van informatie",
    section4_p1: "Elk datapunt binnen handbereik. Werk efficiënt met <strong>nuchterheid</strong>, vertrouwen en technologisch gemak. Geen verloren aanvragen of blinde vlekken meer.",
    section4_p2: "Van PDF-rapporten tot live feeds, van AI-import tot meertaligheid — <strong>Pigeon Supply</strong> maakt complexiteit overzichtelijk.",
    get_started_free: "Gratis Beginnen",
    testimonial: "Pigeon Supply veranderde onze tanklogistiek. Van telefoontjes en spreadsheets naar real-time coördinatie in een week.",
    testimonial_author: "Marc V. / Vlootbeheerder / Bouw NV",
    choose_your_plan: "Kies je plan",
    pricing_desc: "Start gratis. Schaal wanneer nodig. 14 dagen proef op Basic.",
    best_value: "Beste Keuze",
    upgrade_to_unlock: "Upgrade om te ontgrendelen",
    cta_line1: "Klaar om je vloot",
    cta_line2: "aan te sturen?",
    cta_desc: "Start je gratis proefperiode. Geen creditcard nodig.",
    launch_pigeon: "Start Pigeon Supply",
    footer_desc: "Slim bevoorradingsbeheer voor bouwlogistieke teams.",
    product: "Product",
    legal: "Juridisch",
    support: "Ondersteuning",
    terms_of_service: "Algemene Voorwaarden",
    privacy_policy: "Privacybeleid",
    refund_policy: "Terugbetalingsbeleid",
    gdpr_cookies: "GDPR & Cookies",
    contact_us: "Contacteer Ons",
    payment_success: "Betaling gelukt! Welkom bij Pigeon Supply.",
    verifying_payment: "Betaling verifiëren...",
  },
  fr: {
    lobby_title: "Pigeon Supply",
    lobby_subtitle: "Plateforme de Gestion",
    select_hub: "Sélectionner Hub",
    select_role: "Sélectionnez Votre Rôle",
    planner: "Planificateur",
    machinist: "Machiniste",
    driver: "Chauffeur",
    viewer: "Observateur",
    language_gate: "Sélectionnez la Langue",
    enter_dashboard: "Entrer dans le Tableau de Bord",
    back: "Retour",
    exit: "Quitter",
    planner_dashboard: "Tableau de Bord Planificateur",
    fleet_intelligence: "Intelligence Flotte",
    all_regions: "Toutes les Régions",
    search_placeholder: "Rechercher des sites...",
    sites: "Sites",
    machines: "Machines",
    drivers_title: "Chauffeurs",
    active: "Actif",
    offline: "Hors Ligne",
    efficiency: "Efficacité",
    stops: "Arrêts",
    refuelings: "Ravitaillements",
    fleet_volume: "Volume de Flotte",
    active_drivers: "Actif",
    daily_progress: "Progrès Quotidien",
    analyze: "Analyser",
    approve: "Approuver",
    data_synced: "Données Synchronisées",
    ping_sent: "Message Envoyé",
    high_five_sent: "High-Five Envoyé!",
    send_message: "Envoyer Message",
    direct_communication: "Communication Directe",
    send_message_placeholder: "Tapez un message...",
    no_stops_yet: "Pas encore d'arrêts",
    recent_communication: "Communication Récente",
    recent_alerts: "Alertes Récentes",
    live_feed: "Flux en Direct",
    new_requests: "Nouvelles Demandes",
    in_progress: "En Cours",
    completed: "Terminé",
    fun_request: "Demande Fun",
    fun_placeholder: "Frites avec mayonnaise?",
    driver_dashboard: "Tableau de Bord Chauffeur",
    start_day: "Commencer la Journée",
    stop_day: "Terminer la Journée",
    day_status: "Statut du Jour",
    quick_actions: "Actions Rapides",
    pause: "Pause",
    breakdown: "Panne",
    my_planning: "Mon Planning",
    no_planning: "Pas encore de planning",
    checklist: "Checklist Pré-Départ",
    mirrors: "Rétroviseurs & Feux",
    tires: "Pneus & Pression",
    fuel_check: "Niveau de Carburant",
    documents: "Documents & Permis",
    safety_gear: "Équipement de Sécurité",
    confirm_delivery: "Confirmer Livraison",
    diesel_liters: "Diesel (L)",
    adblue_liters: "AdBlue (L)",
    deliver: "Livrer",
    messages: "Messages",
    info_hub: "Centre d'Info",
    high_five_wall: "Mur des High-Fives",
    my_rating: "Ma Note",
    give_planner: "Donner au Planificateur",
    machinist_dashboard: "Tableau de Bord Machiniste",
    select_site: "Sélectionner le Site",
    current_site: "Site Actuel",
    machine_pool: "Parc Machines",
    fuel_request: "Demande de Carburant",
    tank_level: "Niveau du Réservoir",
    adblue_needed: "AdBlue Nécessaire",
    action_center: "Centre d'Action",
    request_type: "Type de Demande",
    in_use: "En Usage",
    defect: "Défaut",
    maintenance: "Entretien",
    transport_needed: "Transport",
    target_destination: "Destination Cible",
    details_reason: "Détails / Raison",
    send_to_planner: "Envoyer au Planificateur",
    add_rental: "Ajouter Machine de Location",
    machine_type: "Type de Machine",
    fleet_id: "ID Flotte / Label",
    confirm_import: "Enregistrer Machine",
    echo_tracker: "Suivi des Demandes",
    waiting: "En Attente",
    loading: "Chargement...",
    error: "Erreur",
    save: "Sauvegarder",
    cancel: "Annuler",
    delete: "Supprimer",
    confirm: "Confirmer",
    no_data: "Aucune donnée",
    refresh: "Rafraîchir",
    calendar: "Calendrier",
    feedback: "Retour",
    feedback_placeholder: "Partagez votre retour sur ce site...",
    submit_feedback: "Envoyer Retour",
    switch_driver: "Changer de Chauffeur",
    reschedule: "Replanifier",
    welcome: "Bienvenue",
    continue_lang: "Continuer",
    choose_language: "Choisissez votre langue pour commencer",
    my_hubs: "Mes Hubs",
    create_hub: "Créer un Hub",
    hub_lobby: "Lobby du Hub",
    hub_occupancy: "Occupation du Hub",
    invite_crew: "Inviter l'Équipe",
    generate_link: "Générer un Lien",
    needed_to_deploy: "Nécessaire pour déployer",
    youre_invited: "Vous Êtes Invité",
    join_as: "Rejoindre en tant que",
    your_role: "Votre Rôle",
    display_name: "Votre Nom d'Affichage",
    how_crew_sees_you: "Comment l'équipe vous voit",
    invite_used: "Invitation Utilisée",
    invite_used_desc: "Ce lien d'invitation a déjà été utilisé",
    go_to_hubs: "Aller à Mes Hubs",
    join_the_crew: "Rejoignez l'équipe et commencez à travailler",
    active_crew: "Équipe Active",
    enter_hub: "Entrer dans le Hub",
    deploy_hub: "Déployer le Hub",
    hub_waiting: "En attente de l'équipe",
    hub_deployed: "Déployé",
    qr_code: "QR Code",
    share: "Partager",
    copy: "Copier",
    copied: "Copié",
    download: "Télécharger",
    install_app: "Installer l'App",
    install_title: "Installer Pigeon Supply",
    install_desc: "Fonctionne hors ligne. Rapide. Sensation native sur tout appareil.",
    your_device: "Votre Appareil",
    how_to_install: "Comment installer",
    app_installed: "App Installée",
    open_app: "Ouvrir Pigeon Supply",
    hub_analytics: "Analyse du Hub",
    total_deliveries: "Total Livraisons",
    feedback_score: "Score Feedback",
    activity_30d: "Activité (30 jours)",
    subjects_per_site: "Sujets par Site",
    settings: "Paramètres",
    language: "Langue",
    notifications: "Notifications",
    profile: "Profil",
    hub_details: "Détails du Hub",
    members: "Membres",
    supply_platform: "Plateforme Logistique",
    nav_pricing: "Tarifs",
    nav_contact: "Contact",
    launch_app: "Lancer l'App",
    hero_badge: "Adopté par des équipes logistiques à travers l'Europe",
    hero_line1: "Approvisionnez vos chantiers.",
    hero_line2: "Pilotez",
    hero_line3: "votre flotte.",
    hero_desc: "La plateforme intelligente de gestion des approvisionnements pour le BTP. Communication en boucle fermée entre Planificateurs, Chauffeurs et Machinistes — en temps réel.",
    start_free_trial: "Essai Gratuit",
    view_pricing: "Voir les Tarifs",
    stat_hubs: "Hubs Actifs",
    stat_drivers: "Chauffeurs Gérés",
    stat_tracked: "Litres Suivis",
    stat_languages: "Langues",
    section1_tag: "Intelligence Terrain",
    section1_line1: "Évaluez la",
    section1_line2: "situation en un clin d'œil",
    section1_p1: "Équipez vos équipes terrain d'apps dédiées. Le <strong>Portail Machiniste</strong> permet les demandes en direct, le suivi machine et les besoins de location — depuis le chantier.",
    section1_p2: "Les accès chantier et vérifications passent par l'<strong>Echo Tank</strong>. L'<strong>App Chauffeur</strong> met à jour les livraisons et capte les retours par trajet.",
    section2_tag: "Décisions Stratégiques",
    section2_line1: "Prenez les bonnes décisions",
    section2_line2: "en toute",
    section2_line3: "confiance",
    section2_p1: "Prenez les décisions qui comptent. <strong>Élargissez votre périmètre</strong> — ajoutez chantiers, régions et corridors d'approvisionnement au fil de vos projets.",
    section2_p2: "Invitez des sous-traitants et assignez-les facilement. Gérez chaque détail avec des <strong>contrôles instantanés</strong> et une visibilité totale.",
    section3_tag: "Vision Globale",
    section3_line1: "Gardez une",
    section3_line2: "vue d'ensemble",
    section3_line3: "complète",
    section3_p1: "Le <strong>Tableau de Bord Planificateur</strong> est votre centre de commande — gérez planning, routes et profils depuis un seul écran.",
    section3_p2: "Des <strong>portails Service et Transport</strong> dédiés coordonnent les équipes spécialisées. Dirigez votre flotte avec une visibilité opérationnelle totale.",
    section4_tag: "Maîtrise Opérationnelle",
    section4_line1: "Profitez du",
    section4_line2: "flux libre",
    section4_line3: "d'information",
    section4_p1: "Chaque donnée à portée de main. Travaillez avec <strong>efficacité</strong>, confiance et aisance technologique. Plus d'angles morts ni de demandes perdues.",
    section4_p2: "Des rapports PDF aux flux temps réel, de l'import IA au multilingue — <strong>Pigeon Supply</strong> transforme la complexité en clarté.",
    get_started_free: "Commencer Gratuitement",
    testimonial: "Pigeon Supply a transformé notre logistique carburant. Des appels et tableurs à la coordination temps réel en une semaine.",
    testimonial_author: "Marc V. / Gestionnaire de Flotte / Construction SA",
    choose_your_plan: "Choisissez votre plan",
    pricing_desc: "Démarrez gratuitement. Évoluez quand vous êtes prêt.",
    best_value: "Meilleur Choix",
    upgrade_to_unlock: "Passez au niveau supérieur",
    cta_line1: "Prêt à piloter",
    cta_line2: "votre flotte ?",
    cta_desc: "Essai gratuit de 14 jours. Sans carte bancaire.",
    launch_pigeon: "Lancer Pigeon Supply",
    footer_desc: "Gestion intelligente des approvisionnements pour le BTP.",
    product: "Produit",
    legal: "Mentions Légales",
    support: "Support",
    terms_of_service: "Conditions Générales",
    privacy_policy: "Politique de Confidentialité",
    refund_policy: "Politique de Remboursement",
    gdpr_cookies: "RGPD & Cookies",
    contact_us: "Nous Contacter",
    payment_success: "Paiement réussi ! Bienvenue chez Pigeon Supply.",
    verifying_payment: "Vérification du paiement...",
  },
  de: {
    lobby_title: "Pigeon Supply",
    lobby_subtitle: "Versorgungsplattform",
    select_hub: "Hub Auswählen",
    select_role: "Wählen Sie Ihre Rolle",
    planner: "Planer",
    machinist: "Maschinist",
    driver: "Fahrer",
    viewer: "Zuschauer",
    language_gate: "Sprache Auswählen",
    enter_dashboard: "Dashboard Öffnen",
    back: "Zurück",
    exit: "Beenden",
    planner_dashboard: "Planer Dashboard",
    fleet_intelligence: "Flotten Intelligenz",
    all_regions: "Alle Regionen",
    search_placeholder: "Baustellen suchen...",
    sites: "Baustellen",
    machines: "Maschinen",
    drivers_title: "Fahrer",
    active: "Aktiv",
    offline: "Offline",
    efficiency: "Effizienz",
    stops: "Stopps",
    refuelings: "Betankungen",
    fleet_volume: "Flottenvolumen",
    active_drivers: "Aktiv",
    daily_progress: "Tagesfortschritt",
    analyze: "Analysieren",
    approve: "Genehmigen",
    data_synced: "Daten Synchronisiert",
    ping_sent: "Nachricht Gesendet",
    high_five_sent: "High-Five Gesendet!",
    send_message: "Nachricht Senden",
    direct_communication: "Direkte Kommunikation",
    send_message_placeholder: "Nachricht eingeben...",
    no_stops_yet: "Noch keine Stopps",
    recent_communication: "Letzte Kommunikation",
    recent_alerts: "Letzte Meldungen",
    live_feed: "Live Feed",
    new_requests: "Neue Anfragen",
    in_progress: "In Bearbeitung",
    completed: "Abgeschlossen",
    fun_request: "Spaß-Anfrage",
    fun_placeholder: "Pommes mit Mayo?",
    driver_dashboard: "Fahrer Dashboard",
    start_day: "Tag Starten",
    stop_day: "Tag Beenden",
    day_status: "Tagesstatus",
    quick_actions: "Schnelle Aktionen",
    pause: "Pause",
    breakdown: "Panne",
    my_planning: "Meine Planung",
    no_planning: "Noch keine Planung",
    checklist: "Abfahrtskontrolle",
    mirrors: "Spiegel & Lichter",
    tires: "Reifen & Druck",
    fuel_check: "Kraftstoffstand",
    documents: "Dokumente & Führerschein",
    safety_gear: "Sicherheitsausrüstung",
    confirm_delivery: "Lieferung Bestätigen",
    diesel_liters: "Diesel (L)",
    adblue_liters: "AdBlue (L)",
    deliver: "Liefern",
    messages: "Nachrichten",
    info_hub: "Info Hub",
    high_five_wall: "High-Five Wand",
    my_rating: "Meine Bewertung",
    give_planner: "Planer Bewerten",
    machinist_dashboard: "Maschinist Dashboard",
    select_site: "Baustelle Auswählen",
    current_site: "Aktuelle Baustelle",
    machine_pool: "Maschinenpark",
    fuel_request: "Tankanfrage",
    tank_level: "Tankstand",
    adblue_needed: "AdBlue Benötigt",
    action_center: "Aktionszentrum",
    request_type: "Anfragetyp",
    in_use: "In Benutzung",
    defect: "Defekt",
    maintenance: "Wartung",
    transport_needed: "Transport",
    target_destination: "Zielort",
    details_reason: "Details / Grund",
    send_to_planner: "An Planer Senden",
    add_rental: "Mietmaschine Hinzufügen",
    machine_type: "Maschinentyp",
    fleet_id: "Flotten ID / Label",
    confirm_import: "Maschine Registrieren",
    echo_tracker: "Anfrage Tracker",
    waiting: "Wartend",
    loading: "Laden...",
    error: "Fehler",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    confirm: "Bestätigen",
    no_data: "Keine Daten",
    refresh: "Aktualisieren",
    calendar: "Kalender",
    feedback: "Feedback",
    feedback_placeholder: "Teilen Sie Ihr Feedback zu dieser Baustelle...",
    submit_feedback: "Feedback Senden",
    switch_driver: "Fahrer Wechseln",
    reschedule: "Umplanen",
    welcome: "Willkommen",
    continue_lang: "Weiter",
    choose_language: "Wählen Sie Ihre Sprache",
    my_hubs: "Meine Hubs",
    create_hub: "Hub Erstellen",
    hub_lobby: "Hub Lobby",
    hub_occupancy: "Hub Belegung",
    invite_crew: "Crew Einladen",
    generate_link: "Link Generieren",
    needed_to_deploy: "Benötigt für Deployment",
    youre_invited: "Sie Sind Eingeladen",
    join_as: "Beitreten als",
    your_role: "Ihre Rolle",
    display_name: "Ihr Anzeigename",
    how_crew_sees_you: "So sieht die Crew Sie",
    invite_used: "Einladung Verwendet",
    invite_used_desc: "Dieser Einladungslink wurde bereits verwendet",
    go_to_hubs: "Zu Meinen Hubs",
    join_the_crew: "Treten Sie dem Team bei und beginnen Sie",
    active_crew: "Aktive Crew",
    enter_hub: "Hub Dashboard Öffnen",
    deploy_hub: "Hub Deployen",
    hub_waiting: "Wartet auf Crew",
    hub_deployed: "Deployed",
    qr_code: "QR Code",
    share: "Teilen",
    copy: "Kopieren",
    copied: "Kopiert",
    download: "Herunterladen",
    install_app: "App Installieren",
    install_title: "Pigeon Supply Installieren",
    install_desc: "Funktioniert offline. Schnell. Natives Gefühl auf jedem Gerät.",
    your_device: "Ihr Gerät",
    how_to_install: "So installieren Sie",
    app_installed: "App Installiert",
    open_app: "Pigeon Supply Öffnen",
    hub_analytics: "Hub Analyse",
    total_deliveries: "Gesamt Lieferungen",
    feedback_score: "Feedback-Bewertung",
    activity_30d: "Aktivität (30 Tage)",
    subjects_per_site: "Maschinen pro Standort",
    settings: "Einstellungen",
    language: "Sprache",
    notifications: "Benachrichtigungen",
    profile: "Profil",
    hub_details: "Hub Details",
    members: "Mitglieder",
    supply_platform: "Logistik-Plattform",
    nav_pricing: "Preise",
    nav_contact: "Kontakt",
    launch_app: "App Starten",
    hero_badge: "Vertraut von Logistikteams in ganz Europa",
    hero_line1: "Versorge deine Baustellen.",
    hero_line2: "Steuere",
    hero_line3: "deine Flotte.",
    hero_desc: "Die intelligente Versorgungsplattform für Baulogistik. Geschlossene Kommunikation zwischen Planern, Fahrern und Maschinisten — in Echtzeit.",
    start_free_trial: "Kostenlos Testen",
    view_pricing: "Preise Ansehen",
    stat_hubs: "Aktive Hubs",
    stat_drivers: "Fahrer Verwaltet",
    stat_tracked: "Liter Erfasst",
    stat_languages: "Sprachen",
    section1_tag: "Vor-Ort-Intelligenz",
    section1_line1: "Erfasse die",
    section1_line2: "Lage auf einen Blick",
    section1_p1: "Rüste dein Feldteam mit spezialisierten Apps aus. Das <strong>Maschinist-Portal</strong> ermöglicht Live-Anfragen, Maschinenstatus und Mietbedarf — direkt von der Baustelle.",
    section1_p2: "Zugangsinfos und Lieferprüfungen laufen über den <strong>Echo Tank</strong>. Die <strong>Fahrer-App</strong> aktualisiert Lieferungen und erfasst Feedback pro Tour.",
    section2_tag: "Strategische Entscheidungen",
    section2_line1: "Triff die richtigen Entscheidungen",
    section2_line2: "mit",
    section2_line3: "Zuversicht",
    section2_p1: "Triff die Entscheidungen, die zählen. <strong>Erweitere deinen Aktionsradius</strong> — füge Baustellen, Regionen und Versorgungskorridore hinzu.",
    section2_p2: "Lade Subunternehmer ein und weise sie nahtlos zu. Organisiere Betankung im Detail mit <strong>sofortigen Lieferprüfungen</strong> und voller Übersicht.",
    section3_tag: "Komplettüberblick",
    section3_line1: "Behalte den",
    section3_line2: "Überblick",
    section3_line3: "von oben",
    section3_p1: "Das <strong>Planer-Dashboard</strong> ist deine Kommandozentrale — verwalte Fahrerplanung, Routenzuweisung und Profile auf einem Bildschirm.",
    section3_p2: "<strong>Service- und Transportportale</strong> halten Spezialteams synchron. Lenke deine Flotte mit voller operativer Sicht.",
    section4_tag: "Operative Kontrolle",
    section4_line1: "Genieße den",
    section4_line2: "freien Fluss",
    section4_line3: "der Information",
    section4_p1: "Jeder Datenpunkt griffbereit. Arbeite effizient mit <strong>Pragmatismus</strong>, Vertrauen und technologischer Leichtigkeit. Keine verlorenen Anfragen mehr.",
    section4_p2: "Von PDF-Berichten bis Live-Feeds, von KI-Import bis Mehrsprachigkeit — <strong>Pigeon Supply</strong> macht Komplexität übersichtlich.",
    get_started_free: "Kostenlos Starten",
    testimonial: "Pigeon Supply hat unsere Tanklogistik revolutioniert. Von Anrufen und Tabellen zu Echtzeit-Koordination in einer Woche.",
    testimonial_author: "Marc V. / Flottenmanager / Bau GmbH",
    choose_your_plan: "Wähle deinen Plan",
    pricing_desc: "Starte kostenlos. Skaliere wenn nötig.",
    best_value: "Beste Wahl",
    upgrade_to_unlock: "Upgraden zum Freischalten",
    cta_line1: "Bereit deine Flotte",
    cta_line2: "zu lenken?",
    cta_desc: "14 Tage kostenlos testen. Keine Kreditkarte nötig.",
    launch_pigeon: "Pigeon Supply Starten",
    footer_desc: "Intelligentes Versorgungsmanagement für Baulogistik.",
    product: "Produkt",
    legal: "Rechtliches",
    support: "Support",
    terms_of_service: "Nutzungsbedingungen",
    privacy_policy: "Datenschutzrichtlinie",
    refund_policy: "Erstattungsrichtlinie",
    gdpr_cookies: "DSGVO & Cookies",
    contact_us: "Kontaktiere Uns",
    payment_success: "Zahlung erfolgreich! Willkommen bei Pigeon Supply.",
    verifying_payment: "Zahlung wird geprüft...",
  },
  pl: {
    lobby_title: "Pigeon Supply",
    lobby_subtitle: "Platforma Zaopatrzenia",
    select_hub: "Wybierz Hub",
    select_role: "Wybierz Swoją Rolę",
    planner: "Planista",
    machinist: "Maszynista",
    driver: "Kierowca",
    viewer: "Obserwator",
    language_gate: "Wybierz Język",
    enter_dashboard: "Wejdź do Panelu",
    back: "Wstecz",
    exit: "Wyjście",
    planner_dashboard: "Panel Planisty",
    fleet_intelligence: "Inteligencja Floty",
    all_regions: "Wszystkie Regiony",
    search_placeholder: "Szukaj placów budowy...",
    sites: "Place Budowy",
    machines: "Maszyny",
    drivers_title: "Kierowcy",
    active: "Aktywny",
    offline: "Offline",
    efficiency: "Wydajność",
    stops: "Postoje",
    refuelings: "Tankowania",
    fleet_volume: "Objętość Floty",
    active_drivers: "Aktywni",
    daily_progress: "Postęp Dzienny",
    analyze: "Analizuj",
    approve: "Zatwierdź",
    data_synced: "Dane Zsynchronizowane",
    ping_sent: "Wiadomość Wysłana",
    high_five_sent: "Piątka Wysłana!",
    send_message: "Wyślij Wiadomość",
    direct_communication: "Komunikacja Bezpośrednia",
    send_message_placeholder: "Wpisz wiadomość...",
    no_stops_yet: "Brak postojów",
    recent_communication: "Ostatnia Komunikacja",
    recent_alerts: "Ostatnie Alerty",
    live_feed: "Na Żywo",
    new_requests: "Nowe Zgłoszenia",
    in_progress: "W Trakcie",
    completed: "Zakończone",
    fun_request: "Prośba Specjalna",
    fun_placeholder: "Frytki z majonezem?",
    driver_dashboard: "Panel Kierowcy",
    start_day: "Rozpocznij Dzień",
    stop_day: "Zakończ Dzień",
    day_status: "Status Dnia",
    quick_actions: "Szybkie Akcje",
    pause: "Przerwa",
    breakdown: "Awaria",
    my_planning: "Mój Plan",
    no_planning: "Brak planu",
    checklist: "Lista Kontrolna",
    mirrors: "Lusterka i Światła",
    tires: "Opony i Ciśnienie",
    fuel_check: "Poziom Paliwa",
    documents: "Dokumenty i Prawo Jazdy",
    safety_gear: "Wyposażenie BHP",
    confirm_delivery: "Potwierdź Dostawę",
    diesel_liters: "Diesel (L)",
    adblue_liters: "AdBlue (L)",
    deliver: "Dostarcz",
    messages: "Wiadomości",
    info_hub: "Centrum Info",
    high_five_wall: "Ściana Piątek",
    my_rating: "Moja Ocena",
    give_planner: "Oceń Planistę",
    machinist_dashboard: "Panel Maszynisty",
    select_site: "Wybierz Plac",
    current_site: "Aktualny Plac",
    machine_pool: "Park Maszynowy",
    fuel_request: "Zgłoszenie Paliwa",
    tank_level: "Poziom Zbiornika",
    adblue_needed: "Potrzeba AdBlue",
    action_center: "Centrum Akcji",
    request_type: "Typ Zgłoszenia",
    in_use: "W Użyciu",
    defect: "Usterka",
    maintenance: "Konserwacja",
    transport_needed: "Transport",
    target_destination: "Miejsce Docelowe",
    details_reason: "Szczegóły / Powód",
    send_to_planner: "Wyślij do Planisty",
    add_rental: "Dodaj Maszynę Wynajętą",
    machine_type: "Typ Maszyny",
    fleet_id: "ID Floty / Etykieta",
    confirm_import: "Zarejestruj Maszynę",
    echo_tracker: "Śledzenie Zgłoszeń",
    waiting: "Oczekiwanie",
    loading: "Ładowanie...",
    error: "Błąd",
    save: "Zapisz",
    cancel: "Anuluj",
    delete: "Usuń",
    confirm: "Potwierdź",
    no_data: "Brak danych",
    refresh: "Odśwież",
    calendar: "Kalendarz",
    feedback: "Opinia",
    feedback_placeholder: "Podziel się opinią o tym placu...",
    submit_feedback: "Wyślij Opinię",
    switch_driver: "Zmień Kierowcę",
    reschedule: "Przełóż",
    welcome: "Witaj",
    continue_lang: "Kontynuuj",
    choose_language: "Wybierz język, aby rozpocząć",
    my_hubs: "Moje Huby",
    create_hub: "Utwórz Hub",
    hub_lobby: "Lobby Huba",
    hub_occupancy: "Obłożenie Huba",
    invite_crew: "Zaproś Załogę",
    generate_link: "Wygeneruj Link",
    needed_to_deploy: "Wymagane do wdrożenia",
    youre_invited: "Zostałeś Zaproszony",
    join_as: "Dołącz jako",
    your_role: "Twoja Rola",
    display_name: "Twoja Nazwa",
    how_crew_sees_you: "Jak załoga Cię widzi",
    invite_used: "Zaproszenie Wykorzystane",
    invite_used_desc: "Ten link zaproszenia został już wykorzystany",
    go_to_hubs: "Idź do Moich Hubów",
    join_the_crew: "Dołącz do załogi i zacznij pracować",
    active_crew: "Aktywna Załoga",
    enter_hub: "Wejdź do Dashboardu",
    deploy_hub: "Wdróż Hub",
    hub_waiting: "Oczekiwanie na załogę",
    hub_deployed: "Wdrożony",
    qr_code: "Kod QR",
    share: "Udostępnij",
    copy: "Kopiuj",
    copied: "Skopiowano",
    download: "Pobierz",
    install_app: "Zainstaluj Aplikację",
    install_title: "Zainstaluj Pigeon Supply",
    install_desc: "Działa offline. Szybka. Natywne wrażenie na każdym urządzeniu.",
    your_device: "Twoje Urządzenie",
    how_to_install: "Jak zainstalować",
    app_installed: "Aplikacja Zainstalowana",
    open_app: "Otwórz Pigeon Supply",
    hub_analytics: "Analiza Huba",
    total_deliveries: "Łącznie Dostaw",
    feedback_score: "Ocena Feedbacku",
    activity_30d: "Aktywność (30 dni)",
    subjects_per_site: "Maszyny na Plac",
    settings: "Ustawienia",
    language: "Język",
    notifications: "Powiadomienia",
    profile: "Profil",
    hub_details: "Szczegóły Huba",
    members: "Członkowie",
    supply_platform: "Platforma Logistyczna",
    nav_pricing: "Cennik",
    nav_contact: "Kontakt",
    launch_app: "Uruchom",
    hero_badge: "Zaufanie zespołów logistycznych w całej Europie",
    hero_line1: "Zaopatrz swoje place.",
    hero_line2: "Zarządzaj",
    hero_line3: "swoją flotą.",
    hero_desc: "Inteligentna platforma zaopatrzenia dla budownictwa. Komunikacja w pętli zamkniętej między Planistami, Kierowcami i Maszynistami — na żywo.",
    start_free_trial: "Wypróbuj Za Darmo",
    view_pricing: "Zobacz Cennik",
    stat_hubs: "Aktywne Huby",
    stat_drivers: "Kierowców",
    stat_tracked: "Litrów Śledzonych",
    stat_languages: "Języków",
    section1_tag: "Inteligencja Terenowa",
    section1_line1: "Oceń",
    section1_line2: "sytuację błyskawicznie",
    section1_p1: "Wyposaż ekipę terenową w dedykowane aplikacje. <strong>Portal Maszynisty</strong> umożliwia zgłoszenia, status maszyn i potrzeby wynajmu — prosto z placu.",
    section1_p2: "Dojazdy i weryfikacje dostaw przepływają przez <strong>Echo Tank</strong>. <strong>Aplikacja Kierowcy</strong> aktualizuje dostawy i zbiera opinie na bieżąco.",
    section2_tag: "Decyzje Strategiczne",
    section2_line1: "Podejmuj trafne decyzje",
    section2_line2: "z",
    section2_line3: "pewnością",
    section2_p1: "Podejmuj decyzje, które się liczą. <strong>Rozszerzaj zasięg</strong> — dodawaj place, regiony i trasy zaopatrzenia wraz z rozwojem projektów.",
    section2_p2: "Zaproś podwykonawców i przydziel ich sprawnie. Zarządzaj każdym szczegółem z <strong>natychmiastową kontrolą dostaw</strong> i pełną widocznością.",
    section3_tag: "Pełna Widoczność",
    section3_line1: "Utrzymuj",
    section3_line2: "widok z lotu",
    section3_line3: "ptaka",
    section3_p1: "<strong>Dashboard Planisty</strong> to centrum dowodzenia — zarządzaj planowaniem, trasami i profilami z jednego ekranu.",
    section3_p2: "Dedykowane <strong>portale Serwisu i Transportu</strong> synchronizują wyspecjalizowane zespoły. Kieruj flotą z pełnym przeglądem operacyjnym.",
    section4_tag: "Mistrzostwo Operacyjne",
    section4_line1: "Ciesz się",
    section4_line2: "swobodnym przepływem",
    section4_line3: "informacji",
    section4_p1: "Każdy punkt danych w zasięgu ręki. Pracuj z <strong>pragmatyzmem</strong> i technologiczną łatwością. Koniec z zagubionymi zgłoszeniami.",
    section4_p2: "Od raportów PDF po live feedy, od importu AI po wielojęzyczność — <strong>Pigeon Supply</strong> zamienia złożoność w przejrzystość.",
    get_started_free: "Zacznij Za Darmo",
    testimonial: "Pigeon Supply zrewolucjonizował naszą logistykę tankowania. Od telefonów i arkuszy do koordynacji na żywo w tydzień.",
    testimonial_author: "Marc V. / Kierownik Floty / Budownictwo SA",
    choose_your_plan: "Wybierz plan",
    pricing_desc: "Zacznij za darmo. Skaluj gdy potrzebujesz.",
    best_value: "Najlepsza Oferta",
    upgrade_to_unlock: "Ulepsz aby odblokować",
    cta_line1: "Gotowy kierować",
    cta_line2: "swoją flotą?",
    cta_desc: "14 dni za darmo. Bez karty kredytowej.",
    launch_pigeon: "Uruchom Pigeon Supply",
    footer_desc: "Inteligentne zarządzanie zaopatrzeniem dla budownictwa.",
    product: "Produkt",
    legal: "Prawne",
    support: "Wsparcie",
    terms_of_service: "Regulamin",
    privacy_policy: "Polityka Prywatności",
    refund_policy: "Polityka Zwrotów",
    gdpr_cookies: "RODO & Cookies",
    contact_us: "Skontaktuj Się",
    payment_success: "Płatność udana! Witamy w Pigeon Supply.",
    verifying_payment: "Weryfikacja płatności...",
  },
  ro: {
    lobby_title: "Pigeon Supply",
    lobby_subtitle: "Platforma de Aprovizionare",
    select_hub: "Selectează Hub",
    select_role: "Selectează Rolul Tău",
    planner: "Planificator",
    machinist: "Machinist",
    driver: "Șofer",
    viewer: "Observator",
    language_gate: "Selectează Limba",
    enter_dashboard: "Intră în Panou",
    back: "Înapoi",
    exit: "Ieșire",
    planner_dashboard: "Panou Planificator",
    fleet_intelligence: "Inteligența Flotei",
    all_regions: "Toate Regiunile",
    search_placeholder: "Caută șantiere...",
    sites: "Șantiere",
    machines: "Mașini",
    drivers_title: "Șoferi",
    active: "Activ",
    offline: "Offline",
    efficiency: "Eficiență",
    stops: "Opriri",
    refuelings: "Alimentări",
    fleet_volume: "Volum Flotă",
    active_drivers: "Activi",
    daily_progress: "Progres Zilnic",
    analyze: "Analizează",
    approve: "Aprobă",
    data_synced: "Date Sincronizate",
    ping_sent: "Mesaj Trimis",
    high_five_sent: "High-Five Trimis!",
    send_message: "Trimite Mesaj",
    direct_communication: "Comunicare Directă",
    send_message_placeholder: "Scrie un mesaj...",
    no_stops_yet: "Nicio oprire încă",
    recent_communication: "Comunicare Recentă",
    recent_alerts: "Alerte Recente",
    live_feed: "Feed Live",
    new_requests: "Cereri Noi",
    in_progress: "În Curs",
    completed: "Finalizat",
    fun_request: "Cerere Specială",
    fun_placeholder: "Cartofi prăjiți cu maioneză?",
    driver_dashboard: "Panou Șofer",
    start_day: "Începe Ziua",
    stop_day: "Termină Ziua",
    day_status: "Status Zi",
    quick_actions: "Acțiuni Rapide",
    pause: "Pauză",
    breakdown: "Defecțiune",
    my_planning: "Planificarea Mea",
    no_planning: "Nicio planificare încă",
    checklist: "Lista de Verificare",
    mirrors: "Oglinzi și Lumini",
    tires: "Anvelope și Presiune",
    fuel_check: "Nivel Combustibil",
    documents: "Documente și Permis",
    safety_gear: "Echipament de Siguranță",
    confirm_delivery: "Confirmă Livrarea",
    diesel_liters: "Diesel (L)",
    adblue_liters: "AdBlue (L)",
    deliver: "Livrează",
    messages: "Mesaje",
    info_hub: "Centru Info",
    high_five_wall: "Peretele High-Five",
    my_rating: "Evaluarea Mea",
    give_planner: "Evaluează Planificatorul",
    machinist_dashboard: "Panou Machinist",
    select_site: "Selectează Șantierul",
    current_site: "Șantier Actual",
    machine_pool: "Parc Mașini",
    fuel_request: "Cerere Combustibil",
    tank_level: "Nivel Rezervor",
    adblue_needed: "AdBlue Necesar",
    action_center: "Centru Acțiuni",
    request_type: "Tip Cerere",
    in_use: "În Uz",
    defect: "Defect",
    maintenance: "Întreținere",
    transport_needed: "Transport",
    target_destination: "Destinație",
    details_reason: "Detalii / Motiv",
    send_to_planner: "Trimite la Planificator",
    add_rental: "Adaugă Mașină Închiriată",
    machine_type: "Tip Mașină",
    fleet_id: "ID Flotă / Etichetă",
    confirm_import: "Înregistrează Mașina",
    echo_tracker: "Urmărire Cereri",
    waiting: "În Așteptare",
    loading: "Se încarcă...",
    error: "Eroare",
    save: "Salvează",
    cancel: "Anulează",
    delete: "Șterge",
    confirm: "Confirmă",
    no_data: "Fără date",
    refresh: "Reîmprospătează",
    calendar: "Calendar",
    feedback: "Feedback",
    feedback_placeholder: "Împărtășește feedback-ul despre acest șantier...",
    submit_feedback: "Trimite Feedback",
    switch_driver: "Schimbă Șoferul",
    reschedule: "Reprogramează",
    welcome: "Bun venit",
    continue_lang: "Continuă",
    choose_language: "Alegeți limba pentru a începe",
    my_hubs: "Huburile Mele",
    create_hub: "Creează Hub",
    hub_lobby: "Lobby Hub",
    hub_occupancy: "Ocupare Hub",
    invite_crew: "Invită Echipa",
    generate_link: "Generează Link",
    needed_to_deploy: "Necesar pentru lansare",
    youre_invited: "Ești Invitat",
    join_as: "Alătură-te ca",
    your_role: "Rolul Tău",
    display_name: "Numele Tău Afișat",
    how_crew_sees_you: "Cum te vede echipa",
    invite_used: "Invitație Folosită",
    invite_used_desc: "Acest link de invitație a fost deja folosit",
    go_to_hubs: "Mergi la Huburile Mele",
    join_the_crew: "Alătură-te echipei și începe să lucrezi",
    active_crew: "Echipă Activă",
    enter_hub: "Intră în Dashboard",
    deploy_hub: "Lansează Hub",
    hub_waiting: "Așteptare echipă",
    hub_deployed: "Lansat",
    qr_code: "Cod QR",
    share: "Partajează",
    copy: "Copiază",
    copied: "Copiat",
    download: "Descarcă",
    install_app: "Instalează Aplicația",
    install_title: "Instalează Pigeon Supply",
    install_desc: "Funcționează offline. Rapid. Senzație nativă pe orice dispozitiv.",
    your_device: "Dispozitivul Tău",
    how_to_install: "Cum se instalează",
    app_installed: "Aplicație Instalată",
    open_app: "Deschide Pigeon Supply",
    hub_analytics: "Analiză Hub",
    total_deliveries: "Total Livrări",
    feedback_score: "Scor Feedback",
    activity_30d: "Activitate (30 zile)",
    subjects_per_site: "Utilaje per Șantier",
    settings: "Setări",
    language: "Limbă",
    notifications: "Notificări",
    profile: "Profil",
    hub_details: "Detalii Hub",
    members: "Membri",
    supply_platform: "Platformă Logistică",
    nav_pricing: "Tarife",
    nav_contact: "Contact",
    launch_app: "Deschide App",
    hero_badge: "Folosit de echipe logistice din toată Europa",
    hero_line1: "Aprovizionează-ți șantierele.",
    hero_line2: "Conduce-ți",
    hero_line3: "flota.",
    hero_desc: "Platforma inteligentă de aprovizionare pentru construcții. Comunicare închisă între Planificatori, Șoferi și Mecanici — în timp real.",
    start_free_trial: "Încearcă Gratuit",
    view_pricing: "Vezi Tarifele",
    stat_hubs: "Huburi Active",
    stat_drivers: "Șoferi Gestionați",
    stat_tracked: "Litri Urmăriți",
    stat_languages: "Limbi",
    section1_tag: "Inteligență de Teren",
    section1_line1: "Evaluează",
    section1_line2: "situația dintr-o privire",
    section1_p1: "Echipează-ți echipa cu aplicații dedicate. <strong>Portalul Mecanicului</strong> permite cereri live, starea utilajelor și nevoile de închiriere — direct de pe șantier.",
    section1_p2: "Direcțiile de acces și verificările trec prin <strong>Echo Tank</strong>. <strong>App-ul Șoferului</strong> actualizează livrările și colectează feedback pe fiecare cursă.",
    section2_tag: "Decizii Strategice",
    section2_line1: "Ia deciziile corecte",
    section2_line2: "cu",
    section2_line3: "încredere",
    section2_p1: "Ia deciziile care contează. <strong>Extinde-ți raza operațională</strong> — adaugă șantiere, regiuni și rute de aprovizionare.",
    section2_p2: "Invită subcontractori și atribuie-i ușor. Gestionează fiecare detaliu cu <strong>verificări instantanee</strong> și vizibilitate completă.",
    section3_tag: "Viziune Completă",
    section3_line1: "Menține o",
    section3_line2: "perspectivă de ansamblu",
    section3_line3: "totală",
    section3_p1: "<strong>Tabloul Planificatorului</strong> este centrul tău de comandă — gestionează planificarea, rutele și profilurile dintr-un singur ecran.",
    section3_p2: "<strong>Portaluri dedicate</strong> de Service și Transport coordonează echipele. Dirijează-ți flota cu vizibilitate operațională completă.",
    section4_tag: "Stăpânire Operațională",
    section4_line1: "Bucură-te de",
    section4_line2: "fluxul liber",
    section4_line3: "de informație",
    section4_p1: "Fiecare punct de date la îndemână. Lucrează eficient cu <strong>pragmatism</strong> și ușurință tehnologică. Fără cereri pierdute.",
    section4_p2: "De la rapoarte PDF la flux live, de la import AI la multilingvism — <strong>Pigeon Supply</strong> transformă complexitatea în claritate.",
    get_started_free: "Începe Gratuit",
    testimonial: "Pigeon Supply ne-a transformat logistica de alimentare. De la telefoane și tabele la coordonare live într-o săptămână.",
    testimonial_author: "Marc V. / Manager Flotă / Construcții SRL",
    choose_your_plan: "Alege-ți planul",
    pricing_desc: "Începe gratuit. Scalează când ești pregătit.",
    best_value: "Cea Mai Bună Alegere",
    upgrade_to_unlock: "Upgradeză pentru a debloca",
    cta_line1: "Gata să-ți conduci",
    cta_line2: "flota?",
    cta_desc: "14 zile gratuit. Fără card bancar.",
    launch_pigeon: "Lansează Pigeon Supply",
    footer_desc: "Gestionare inteligentă a aprovizionării pentru construcții.",
    product: "Produs",
    legal: "Legal",
    support: "Suport",
    terms_of_service: "Termeni și Condiții",
    privacy_policy: "Politica de Confidențialitate",
    refund_policy: "Politica de Rambursare",
    gdpr_cookies: "GDPR & Cookies",
    contact_us: "Contactează-ne",
    payment_success: "Plata reușită! Bine ai venit la Pigeon Supply.",
    verifying_payment: "Verificare plată...",
  },
  ar: {
    lobby_title: "Pigeon Supply",
    lobby_subtitle: "منصة إدارة التوريد",
    select_hub: "اختر المركز",
    select_role: "اختر دورك",
    planner: "مخطط",
    machinist: "مشغل آلات",
    driver: "سائق",
    viewer: "مراقب",
    language_gate: "اختر اللغة",
    enter_dashboard: "دخول لوحة القيادة",
    back: "رجوع",
    exit: "خروج",
    planner_dashboard: "لوحة المخطط",
    fleet_intelligence: "ذكاء الأسطول",
    all_regions: "جميع المناطق",
    search_placeholder: "البحث في المواقع...",
    sites: "المواقع",
    machines: "الآلات",
    drivers_title: "السائقون",
    active: "نشط",
    offline: "غير متصل",
    efficiency: "الكفاءة",
    stops: "المحطات",
    refuelings: "التزويد بالوقود",
    fleet_volume: "حجم الأسطول",
    active_drivers: "نشطون",
    daily_progress: "التقدم اليومي",
    analyze: "تحليل",
    approve: "موافقة",
    data_synced: "تم مزامنة البيانات",
    ping_sent: "تم إرسال الرسالة",
    high_five_sent: "تم إرسال التحية!",
    send_message: "إرسال رسالة",
    direct_communication: "اتصال مباشر",
    send_message_placeholder: "اكتب رسالة...",
    no_stops_yet: "لا محطات بعد",
    recent_communication: "الاتصالات الأخيرة",
    recent_alerts: "التنبيهات الأخيرة",
    live_feed: "البث المباشر",
    new_requests: "طلبات جديدة",
    in_progress: "قيد التنفيذ",
    completed: "مكتمل",
    fun_request: "طلب خاص",
    fun_placeholder: "بطاطس مقلية بالمايونيز؟",
    driver_dashboard: "لوحة السائق",
    start_day: "بدء اليوم",
    stop_day: "إنهاء اليوم",
    day_status: "حالة اليوم",
    quick_actions: "إجراءات سريعة",
    pause: "استراحة",
    breakdown: "عطل",
    my_planning: "تخطيطي",
    no_planning: "لا يوجد تخطيط بعد",
    checklist: "قائمة التحقق",
    mirrors: "المرايا والأضواء",
    tires: "الإطارات والضغط",
    fuel_check: "مستوى الوقود",
    documents: "الوثائق والرخصة",
    safety_gear: "معدات السلامة",
    confirm_delivery: "تأكيد التسليم",
    diesel_liters: "ديزل (لتر)",
    adblue_liters: "AdBlue (لتر)",
    deliver: "تسليم",
    messages: "الرسائل",
    info_hub: "مركز المعلومات",
    high_five_wall: "جدار التحيات",
    my_rating: "تقييمي",
    give_planner: "قيّم المخطط",
    machinist_dashboard: "لوحة مشغل الآلات",
    select_site: "اختر الموقع",
    current_site: "الموقع الحالي",
    machine_pool: "مجموعة الآلات",
    fuel_request: "طلب وقود",
    tank_level: "مستوى الخزان",
    adblue_needed: "AdBlue مطلوب",
    action_center: "مركز الإجراءات",
    request_type: "نوع الطلب",
    in_use: "قيد الاستخدام",
    defect: "عيب",
    maintenance: "صيانة",
    transport_needed: "نقل",
    target_destination: "الوجهة المستهدفة",
    details_reason: "التفاصيل / السبب",
    send_to_planner: "إرسال إلى المخطط",
    add_rental: "إضافة آلة مستأجرة",
    machine_type: "نوع الآلة",
    fleet_id: "معرف الأسطول / التسمية",
    confirm_import: "تسجيل الآلة",
    echo_tracker: "تتبع الطلبات",
    waiting: "في الانتظار",
    loading: "جار التحميل...",
    error: "خطأ",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    confirm: "تأكيد",
    no_data: "لا توجد بيانات",
    refresh: "تحديث",
    calendar: "التقويم",
    feedback: "ملاحظات",
    feedback_placeholder: "شارك ملاحظاتك عن هذا الموقع...",
    submit_feedback: "إرسال الملاحظات",
    switch_driver: "تغيير السائق",
    reschedule: "إعادة الجدولة",
    welcome: "مرحباً",
    continue_lang: "متابعة",
    choose_language: "اختر لغتك للبدء",
    my_hubs: "مراكزي",
    create_hub: "إنشاء مركز",
    hub_lobby: "لوبي المركز",
    hub_occupancy: "إشغال المركز",
    invite_crew: "دعوة الطاقم",
    generate_link: "إنشاء رابط",
    needed_to_deploy: "مطلوب للنشر",
    youre_invited: "أنت مدعو",
    join_as: "انضم كـ",
    your_role: "دورك",
    display_name: "اسم العرض",
    how_crew_sees_you: "كيف يراك الطاقم",
    invite_used: "دعوة مستخدمة",
    invite_used_desc: "رابط الدعوة هذا مستخدم بالفعل",
    go_to_hubs: "اذهب إلى مراكزي",
    join_the_crew: "انضم إلى الطاقم وابدأ العمل",
    active_crew: "الطاقم النشط",
    enter_hub: "دخول لوحة المركز",
    deploy_hub: "نشر المركز",
    hub_waiting: "بانتظار الطاقم",
    hub_deployed: "تم النشر",
    qr_code: "رمز QR",
    share: "مشاركة",
    copy: "نسخ",
    copied: "تم النسخ",
    download: "تحميل",
    install_app: "تثبيت التطبيق",
    install_title: "تثبيت Pigeon Supply",
    install_desc: "يعمل بدون إنترنت. سريع. تجربة أصلية على أي جهاز.",
    your_device: "جهازك",
    how_to_install: "كيفية التثبيت",
    app_installed: "تم تثبيت التطبيق",
    open_app: "افتح Pigeon Supply",
    hub_analytics: "تحليلات المركز",
    total_deliveries: "إجمالي التوصيلات",
    feedback_score: "درجة التقييم",
    activity_30d: "النشاط (30 يوم)",
    subjects_per_site: "الآلات لكل موقع",
    settings: "الإعدادات",
    language: "اللغة",
    notifications: "الإشعارات",
    profile: "الملف الشخصي",
    hub_details: "تفاصيل المركز",
    members: "الأعضاء",
    supply_platform: "منصة لوجستية",
    nav_pricing: "الأسعار",
    nav_contact: "اتصل بنا",
    launch_app: "تشغيل",
    hero_badge: "موثوق من فرق لوجستية في أوروبا",
    hero_line1: "زوّد مواقعك.",
    hero_line2: "قُد",
    hero_line3: "أسطولك.",
    hero_desc: "منصة إمداد ذكية للبناء. تواصل مغلق بين المخططين والسائقين والمشغلين — مباشرة.",
    start_free_trial: "تجربة مجانية",
    view_pricing: "عرض الأسعار",
    stat_hubs: "مراكز نشطة",
    stat_drivers: "سائقين",
    stat_tracked: "لتر متتبع",
    stat_languages: "لغات",
    section1_tag: "ذكاء ميداني",
    section1_line1: "قيّم",
    section1_line2: "الوضع بلمح البصر",
    section1_p1: "جهّز فريقك بتطبيقات مخصصة. <strong>بوابة المشغّل</strong> تتيح الطلبات المباشرة وحالة الآلات — من الموقع مباشرة.",
    section1_p2: "التوجيهات والتحقق تمر عبر <strong>Echo Tank</strong>. <strong>تطبيق السائق</strong> يحدّث التوصيلات ويجمع الملاحظات.",
    section2_tag: "قرارات استراتيجية",
    section2_line1: "اتخذ القرارات الصحيحة",
    section2_line2: "بكل",
    section2_line3: "ثقة",
    section2_p1: "اتخذ القرارات المهمة. <strong>وسّع نطاقك</strong> — أضف مواقع ومناطق وممرات إمداد مع نمو مشاريعك.",
    section2_p2: "ادعُ المقاولين وعيّنهم بسلاسة. أدر كل تفصيل مع <strong>فحوصات فورية</strong> ورؤية كاملة.",
    section3_tag: "رؤية شاملة",
    section3_line1: "حافظ على",
    section3_line2: "نظرة شاملة",
    section3_line3: "من الأعلى",
    section3_p1: "<strong>لوحة المخطط</strong> هي مركز قيادتك — أدر التخطيط والمسارات والملفات من شاشة واحدة.",
    section3_p2: "<strong>بوابات الخدمة والنقل</strong> تنسق الفرق المتخصصة. وجّه أسطولك برؤية تشغيلية كاملة.",
    section4_tag: "إتقان تشغيلي",
    section4_line1: "استمتع",
    section4_line2: "بالتدفق الحر",
    section4_line3: "للمعلومات",
    section4_p1: "كل بيانة في متناولك. اعمل بكفاءة وسهولة تقنية. لا طلبات مفقودة بعد الآن.",
    section4_p2: "من تقارير PDF إلى البث المباشر، من استيراد AI إلى تعدد اللغات — <strong>Pigeon Supply</strong> يحوّل التعقيد لوضوح.",
    get_started_free: "ابدأ مجاناً",
    testimonial: "Pigeon Supply غيّر لوجستيات الوقود لدينا. من المكالمات والجداول إلى التنسيق المباشر في أسبوع.",
    testimonial_author: "مارك ف. / مدير الأسطول / شركة إنشاءات",
    choose_your_plan: "اختر خطتك",
    pricing_desc: "ابدأ مجاناً. توسّع عندما تكون جاهزاً.",
    best_value: "أفضل قيمة",
    upgrade_to_unlock: "ترقية لفتح",
    cta_line1: "مستعد لقيادة",
    cta_line2: "أسطولك؟",
    cta_desc: "14 يوم مجاناً. بدون بطاقة ائتمان.",
    launch_pigeon: "تشغيل Pigeon Supply",
    footer_desc: "إدارة إمداد ذكية لفرق البناء.",
    product: "المنتج",
    legal: "قانوني",
    support: "الدعم",
    terms_of_service: "شروط الخدمة",
    privacy_policy: "سياسة الخصوصية",
    refund_policy: "سياسة الاسترداد",
    gdpr_cookies: "GDPR والكوكيز",
    contact_us: "تواصل معنا",
    payment_success: "تمت الدفعة! مرحباً بك في Pigeon Supply.",
    verifying_payment: "التحقق من الدفع...",
  },
  zh: {
    lobby_title: "Pigeon Supply",
    lobby_subtitle: "供应管理平台",
    select_hub: "选择中心",
    select_role: "选择您的角色",
    planner: "规划师",
    machinist: "机械师",
    driver: "司机",
    viewer: "观察者",
    language_gate: "选择语言",
    enter_dashboard: "进入仪表板",
    back: "返回",
    exit: "退出",
    planner_dashboard: "规划师仪表板",
    fleet_intelligence: "车队情报",
    all_regions: "所有区域",
    search_placeholder: "搜索工地...",
    sites: "工地",
    machines: "机械",
    drivers_title: "司机",
    active: "活跃",
    offline: "离线",
    efficiency: "效率",
    stops: "停靠",
    refuelings: "加油",
    fleet_volume: "车队容量",
    active_drivers: "活跃",
    daily_progress: "每日进度",
    analyze: "分析",
    approve: "批准",
    data_synced: "数据已同步",
    ping_sent: "消息已发送",
    high_five_sent: "击掌已发送！",
    send_message: "发送消息",
    direct_communication: "直接通讯",
    send_message_placeholder: "输入消息...",
    no_stops_yet: "暂无停靠",
    recent_communication: "近期通讯",
    recent_alerts: "近期警报",
    live_feed: "实时动态",
    new_requests: "新请求",
    in_progress: "进行中",
    completed: "已完成",
    fun_request: "特殊请求",
    fun_placeholder: "薯条配蛋黄酱？",
    driver_dashboard: "司机仪表板",
    start_day: "开始工作",
    stop_day: "结束工作",
    day_status: "当日状态",
    quick_actions: "快速操作",
    pause: "休息",
    breakdown: "故障",
    my_planning: "我的计划",
    no_planning: "暂无计划",
    checklist: "出发前检查",
    mirrors: "后视镜和灯光",
    tires: "轮胎和气压",
    fuel_check: "燃油液位",
    documents: "证件和驾照",
    safety_gear: "安全装备",
    confirm_delivery: "确认交付",
    diesel_liters: "柴油（升）",
    adblue_liters: "AdBlue（升）",
    deliver: "交付",
    messages: "消息",
    info_hub: "信息中心",
    high_five_wall: "击掌墙",
    my_rating: "我的评分",
    give_planner: "评价规划师",
    machinist_dashboard: "机械师仪表板",
    select_site: "选择工地",
    current_site: "当前工地",
    machine_pool: "机械库",
    fuel_request: "燃油请求",
    tank_level: "油箱液位",
    adblue_needed: "需要AdBlue",
    action_center: "操作中心",
    request_type: "请求类型",
    in_use: "使用中",
    defect: "缺陷",
    maintenance: "维护",
    transport_needed: "运输",
    target_destination: "目标地点",
    details_reason: "详情/原因",
    send_to_planner: "发送给规划师",
    add_rental: "添加租赁机械",
    machine_type: "机械类型",
    fleet_id: "车队编号/标签",
    confirm_import: "注册机械",
    echo_tracker: "请求追踪",
    waiting: "等待中",
    loading: "加载中...",
    error: "错误",
    save: "保存",
    cancel: "取消",
    delete: "删除",
    confirm: "确认",
    no_data: "暂无数据",
    refresh: "刷新",
    calendar: "日历",
    feedback: "反馈",
    feedback_placeholder: "分享您对此工地的反馈...",
    submit_feedback: "提交反馈",
    switch_driver: "切换司机",
    reschedule: "重新安排",
    welcome: "欢迎",
    continue_lang: "继续",
    choose_language: "选择您的语言以开始",
    my_hubs: "我的中心",
    create_hub: "创建中心",
    hub_lobby: "中心大厅",
    hub_occupancy: "中心占用",
    invite_crew: "邀请团队",
    generate_link: "生成链接",
    needed_to_deploy: "部署所需",
    youre_invited: "您被邀请了",
    join_as: "加入为",
    your_role: "您的角色",
    display_name: "您的显示名称",
    how_crew_sees_you: "团队如何看到您",
    invite_used: "邀请已使用",
    invite_used_desc: "此邀请链接已被使用",
    go_to_hubs: "前往我的中心",
    join_the_crew: "加入团队开始工作",
    active_crew: "活跃团队",
    enter_hub: "进入中心仪表板",
    deploy_hub: "部署中心",
    hub_waiting: "等待团队",
    hub_deployed: "已部署",
    qr_code: "二维码",
    share: "分享",
    copy: "复制",
    copied: "已复制",
    download: "下载",
    install_app: "安装应用",
    install_title: "安装 Pigeon Supply",
    install_desc: "离线可用。快速。任何设备上的原生体验。",
    your_device: "您的设备",
    how_to_install: "如何安装",
    app_installed: "应用已安装",
    open_app: "打开 Pigeon Supply",
    hub_analytics: "中心分析",
    total_deliveries: "总配送量",
    feedback_score: "反馈评分",
    activity_30d: "活动 (30天)",
    subjects_per_site: "每个站点的设备",
    settings: "设置",
    language: "语言",
    notifications: "通知",
    profile: "个人资料",
    hub_details: "中心详情",
    members: "成员",
    supply_platform: "物流平台",
    nav_pricing: "定价",
    nav_contact: "联系",
    launch_app: "启动应用",
    hero_badge: "受欧洲物流团队信赖",
    hero_line1: "供应你的工地。",
    hero_line2: "指挥",
    hero_line3: "你的车队。",
    hero_desc: "建筑物流智能供应平台。规划师、司机和机械师之间的闭环通信——实时进行。",
    start_free_trial: "免费试用",
    view_pricing: "查看定价",
    stat_hubs: "活跃中心",
    stat_drivers: "管理司机",
    stat_tracked: "追踪升数",
    stat_languages: "种语言",
    section1_tag: "现场智能",
    section1_line1: "一目了然",
    section1_line2: "掌握现场情况",
    section1_p1: "为现场团队配备专用应用。<strong>机械师门户</strong>实现实时请求、设备状态和租赁需求——直接来自工地。",
    section1_p2: "通行指引和交付验证通过<strong>Echo Tank</strong>流转。<strong>司机应用</strong>实时更新配送并收集反馈。",
    section2_tag: "战略决策",
    section2_line1: "自信做出",
    section2_line2: "正确",
    section2_line3: "决策",
    section2_p1: "做出关键决策。<strong>扩展运营范围</strong>——随项目增长添加工地、区域和供应线路。",
    section2_p2: "邀请承包商并无缝分配。通过<strong>即时交付检查</strong>和完整可视性管理每个细节。",
    section3_tag: "全局视野",
    section3_line1: "保持",
    section3_line2: "鸟瞰式",
    section3_line3: "全局掌控",
    section3_p1: "<strong>规划师仪表板</strong>是您的指挥中心——在一个屏幕上管理调度、路线和配置文件。",
    section3_p2: "专用的<strong>服务和运输门户</strong>协调专业团队。以完整的运营视野指挥您的车队。",
    section4_tag: "运营精通",
    section4_line1: "享受",
    section4_line2: "信息的",
    section4_line3: "自由流动",
    section4_p1: "每个数据点触手可及。以<strong>务实</strong>和技术便利高效工作。不再有丢失的请求。",
    section4_p2: "从PDF报告到实时动态，从AI导入到多语言——<strong>Pigeon Supply</strong>化繁为简。",
    get_started_free: "免费开始",
    testimonial: "Pigeon Supply改变了我们的燃油物流。一周内从电话和表格转为实时协调。",
    testimonial_author: "Marc V. / 车队经理 / 建筑公司",
    choose_your_plan: "选择方案",
    pricing_desc: "免费开始。准备好时扩展。",
    best_value: "最优选择",
    upgrade_to_unlock: "升级以解锁",
    cta_line1: "准备指挥",
    cta_line2: "你的车队？",
    cta_desc: "14天免费试用。无需信用卡。",
    launch_pigeon: "启动 Pigeon Supply",
    footer_desc: "建筑物流智能供应管理。",
    product: "产品",
    legal: "法律",
    support: "支持",
    terms_of_service: "服务条款",
    privacy_policy: "隐私政策",
    refund_policy: "退款政策",
    gdpr_cookies: "GDPR与Cookie",
    contact_us: "联系我们",
    payment_success: "付款成功！欢迎使用Pigeon Supply。",
    verifying_payment: "验证付款...",
  },
  it: {
    lobby_title: "Pigeon Supply",
    lobby_subtitle: "Piattaforma di Gestione",
    select_hub: "Seleziona Hub",
    select_role: "Seleziona il Tuo Ruolo",
    planner: "Pianificatore",
    machinist: "Macchinista",
    driver: "Autista",
    viewer: "Osservatore",
    language_gate: "Seleziona Lingua",
    enter_dashboard: "Entra nel Pannello",
    back: "Indietro",
    exit: "Esci",
    planner_dashboard: "Pannello Pianificatore",
    fleet_intelligence: "Intelligenza Flotta",
    all_regions: "Tutte le Regioni",
    search_placeholder: "Cerca cantieri...",
    sites: "Cantieri",
    machines: "Macchine",
    drivers_title: "Autisti",
    active: "Attivo",
    offline: "Offline",
    efficiency: "Efficienza",
    stops: "Fermate",
    refuelings: "Rifornimenti",
    fleet_volume: "Volume Flotta",
    active_drivers: "Attivi",
    daily_progress: "Progresso Giornaliero",
    analyze: "Analizza",
    approve: "Approva",
    data_synced: "Dati Sincronizzati",
    ping_sent: "Messaggio Inviato",
    high_five_sent: "High-Five Inviato!",
    send_message: "Invia Messaggio",
    direct_communication: "Comunicazione Diretta",
    send_message_placeholder: "Scrivi un messaggio...",
    no_stops_yet: "Nessuna fermata",
    recent_communication: "Comunicazione Recente",
    recent_alerts: "Avvisi Recenti",
    live_feed: "Feed in Diretta",
    new_requests: "Nuove Richieste",
    in_progress: "In Corso",
    completed: "Completato",
    fun_request: "Richiesta Speciale",
    fun_placeholder: "Patatine con maionese?",
    driver_dashboard: "Pannello Autista",
    start_day: "Inizia Giornata",
    stop_day: "Termina Giornata",
    day_status: "Stato del Giorno",
    quick_actions: "Azioni Rapide",
    pause: "Pausa",
    breakdown: "Guasto",
    my_planning: "La Mia Pianificazione",
    no_planning: "Nessuna pianificazione",
    checklist: "Lista Pre-Partenza",
    mirrors: "Specchi e Luci",
    tires: "Pneumatici e Pressione",
    fuel_check: "Livello Carburante",
    documents: "Documenti e Patente",
    safety_gear: "Equipaggiamento Sicurezza",
    confirm_delivery: "Conferma Consegna",
    diesel_liters: "Diesel (L)",
    adblue_liters: "AdBlue (L)",
    deliver: "Consegna",
    messages: "Messaggi",
    info_hub: "Centro Info",
    high_five_wall: "Muro High-Five",
    my_rating: "La Mia Valutazione",
    give_planner: "Valuta Pianificatore",
    machinist_dashboard: "Pannello Macchinista",
    select_site: "Seleziona Cantiere",
    current_site: "Cantiere Attuale",
    machine_pool: "Parco Macchine",
    fuel_request: "Richiesta Carburante",
    tank_level: "Livello Serbatoio",
    adblue_needed: "AdBlue Necessario",
    action_center: "Centro Azioni",
    request_type: "Tipo Richiesta",
    in_use: "In Uso",
    defect: "Difetto",
    maintenance: "Manutenzione",
    transport_needed: "Trasporto",
    target_destination: "Destinazione",
    details_reason: "Dettagli / Motivo",
    send_to_planner: "Invia al Pianificatore",
    add_rental: "Aggiungi Macchina a Noleggio",
    machine_type: "Tipo Macchina",
    fleet_id: "ID Flotta / Etichetta",
    confirm_import: "Registra Macchina",
    echo_tracker: "Tracciamento Richieste",
    waiting: "In Attesa",
    loading: "Caricamento...",
    error: "Errore",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    confirm: "Conferma",
    no_data: "Nessun dato",
    refresh: "Aggiorna",
    calendar: "Calendario",
    feedback: "Feedback",
    feedback_placeholder: "Condividi il tuo feedback su questo cantiere...",
    submit_feedback: "Invia Feedback",
    switch_driver: "Cambia Autista",
    reschedule: "Ripianifica",
    welcome: "Benvenuto",
    continue_lang: "Continua",
    choose_language: "Scegli la tua lingua per iniziare",
    my_hubs: "I Miei Hub",
    create_hub: "Crea Hub",
    hub_lobby: "Lobby Hub",
    hub_occupancy: "Occupazione Hub",
    invite_crew: "Invita l'Equipaggio",
    generate_link: "Genera Link",
    needed_to_deploy: "Necessario per il deploy",
    youre_invited: "Sei Invitato",
    join_as: "Unisciti come",
    your_role: "Il Tuo Ruolo",
    display_name: "Il Tuo Nome Visualizzato",
    how_crew_sees_you: "Come l'equipaggio ti vede",
    invite_used: "Invito Utilizzato",
    invite_used_desc: "Questo link di invito è già stato utilizzato",
    go_to_hubs: "Vai ai Miei Hub",
    join_the_crew: "Unisciti all'equipaggio e inizia a lavorare",
    active_crew: "Equipaggio Attivo",
    enter_hub: "Entra nel Dashboard",
    deploy_hub: "Deploy Hub",
    hub_waiting: "In attesa dell'equipaggio",
    hub_deployed: "Deployato",
    qr_code: "Codice QR",
    share: "Condividi",
    copy: "Copia",
    copied: "Copiato",
    download: "Scarica",
    install_app: "Installa App",
    install_title: "Installa Pigeon Supply",
    install_desc: "Funziona offline. Veloce. Sensazione nativa su qualsiasi dispositivo.",
    your_device: "Il Tuo Dispositivo",
    how_to_install: "Come installare",
    app_installed: "App Installata",
    open_app: "Apri Pigeon Supply",
    hub_analytics: "Analisi Hub",
    total_deliveries: "Totale Consegne",
    feedback_score: "Punteggio Feedback",
    activity_30d: "Attività (30 giorni)",
    subjects_per_site: "Soggetti per Sito",
    settings: "Impostazioni",
    language: "Lingua",
    notifications: "Notifiche",
    profile: "Profilo",
    hub_details: "Dettagli Hub",
    members: "Membri",
    supply_platform: "Piattaforma Logistica",
    nav_pricing: "Prezzi",
    nav_contact: "Contatto",
    launch_app: "Avvia App",
    hero_badge: "Scelto da team logistici in tutta Europa",
    hero_line1: "Rifornisci i tuoi cantieri.",
    hero_line2: "Governa",
    hero_line3: "la tua flotta.",
    hero_desc: "La piattaforma intelligente di approvvigionamento per l'edilizia. Comunicazione a circuito chiuso tra Pianificatori, Autisti e Macchinisti — in tempo reale.",
    start_free_trial: "Prova Gratuita",
    view_pricing: "Vedi Prezzi",
    stat_hubs: "Hub Attivi",
    stat_drivers: "Autisti Gestiti",
    stat_tracked: "Litri Tracciati",
    stat_languages: "Lingue",
    section1_tag: "Intelligenza sul Campo",
    section1_line1: "Valuta la",
    section1_line2: "situazione in un attimo",
    section1_p1: "Equipaggia il team con app dedicate. Il <strong>Portale Macchinista</strong> permette richieste live, stato macchine e fabbisogni — direttamente dal cantiere.",
    section1_p2: "Indicazioni e verifiche passano per l'<strong>Echo Tank</strong>. L'<strong>App Autista</strong> aggiorna le consegne e raccoglie feedback per ogni viaggio.",
    section2_tag: "Scelte Strategiche",
    section2_line1: "Prendi le decisioni giuste",
    section2_line2: "con",
    section2_line3: "sicurezza",
    section2_p1: "Prendi le decisioni che contano. <strong>Espandi il raggio operativo</strong> — aggiungi cantieri, aree e corridoi di fornitura man mano che cresci.",
    section2_p2: "Invita subappaltatori e assegnali facilmente. Gestisci ogni dettaglio con <strong>controlli istantanei</strong> e visibilità totale.",
    section3_tag: "Visione Totale",
    section3_line1: "Mantieni una",
    section3_line2: "visione d'insieme",
    section3_line3: "completa",
    section3_p1: "La <strong>Dashboard Pianificatore</strong> è il tuo centro di comando — gestisci pianificazione, percorsi e profili da un unico schermo.",
    section3_p2: "<strong>Portali Service e Trasporto</strong> dedicati coordinano team specializzati. Guida la flotta con piena visibilità operativa.",
    section4_tag: "Padronanza Operativa",
    section4_line1: "Goditi il",
    section4_line2: "flusso libero",
    section4_line3: "di informazioni",
    section4_p1: "Ogni dato a portata di mano. Lavora con <strong>pragmatismo</strong> e facilità tecnologica. Niente più richieste perse.",
    section4_p2: "Da report PDF a feed live, da import AI al multilingua — <strong>Pigeon Supply</strong> trasforma la complessità in chiarezza.",
    get_started_free: "Inizia Gratis",
    testimonial: "Pigeon Supply ha rivoluzionato la nostra logistica carburante. Da telefonate e fogli di calcolo a coordinamento live in una settimana.",
    testimonial_author: "Marc V. / Fleet Manager / Costruzioni Srl",
    choose_your_plan: "Scegli il tuo piano",
    pricing_desc: "Inizia gratis. Scala quando sei pronto.",
    best_value: "Migliore Scelta",
    upgrade_to_unlock: "Aggiorna per sbloccare",
    cta_line1: "Pronto a guidare",
    cta_line2: "la tua flotta?",
    cta_desc: "14 giorni gratis. Senza carta di credito.",
    launch_pigeon: "Avvia Pigeon Supply",
    footer_desc: "Gestione intelligente forniture per l'edilizia.",
    product: "Prodotto",
    legal: "Legale",
    support: "Supporto",
    terms_of_service: "Termini di Servizio",
    privacy_policy: "Privacy Policy",
    refund_policy: "Politica Rimborsi",
    gdpr_cookies: "GDPR & Cookie",
    contact_us: "Contattaci",
    payment_success: "Pagamento riuscito! Benvenuto in Pigeon Supply.",
    verifying_payment: "Verifica pagamento...",
  },
};

export function useTranslation(lang) {
  const storedLang = typeof window !== 'undefined' && localStorage.getItem("pigeon-lang");
  const resolvedLang = storedLang || lang || "en";
  const t = (key) => {
    const dict = TRANSLATIONS[resolvedLang] || TRANSLATIONS.en;
    return dict[key] || TRANSLATIONS.en[key] || key;
  };
  return { t, lang: resolvedLang };
}

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", flag: "EN" },
  { code: "nl", label: "Nederlands", flag: "NL" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "pl", label: "Polski", flag: "PL" },
  { code: "ro", label: "Română", flag: "RO" },
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "zh", label: "中文", flag: "ZH" },
  { code: "ar", label: "العربية", flag: "AR" },
];

export default TRANSLATIONS;
